/* eslint-disable max-lines-per-function */
import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import FundoAmarelo from '../../../assets/fundo_amarelo.png';
import { Growl } from 'primereact/growl';

import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { CadastrarMidia } from './atom/CadastrarMidia.jsx';
import { VincularGrupo } from './atom/VincularGrupo.jsx';
import { ExcluirRegistro } from './atom/ExcluirRegistro.jsx';
import { Column } from 'primereact/column';
import 'primeicons/primeicons.css';
import { EditarMidia } from './atom/EditarMidia.jsx';
import { VisualizarMidia } from './atom/VisualizarMidia.jsx';
import MidiaService from '../../../services/tvs/midiaServices.js';

import grupoTvService from '../../../services/tvs/grupoTvService';
import { mostrarMensagemSucesso } from '../shared/getMensagens';

import './style.css';

export function UploadMidias() {
    const [dadosParametros, setDadosParametros] = useState([]);
    const [modalAberto, setModalAberto] = useState(false);
    const [modalEdicaoAberto, setModalEdicaoAberto] = useState(false);
    const [modalVincularTVAberto, setModalVisualizarMidiaAberto] = useState(false);
    const [vincularGruposAberto, setModalVincularGruposAberto] = useState(false);
    const [recarregarDataTable, setRecarregarDataTable] = useState(true);
    const [rowSelecionada, setRowSelecionada] = useState([]);
    const [openModalCadastro,setOpenModalCadastro] = useState(false);
    const [dadosGrupo, setDadosGrupo] = useState([]);
    const [dados, setDados] = useState();
    const [mensagem, setMensagem] = useState(false);

    const abrirModal = () => setModalAberto(true);
    const abrirModalEdicao = () => setModalEdicaoAberto(true);
    const abrirModalVisualizarMidia = () => setModalVisualizarMidiaAberto(true);
    const abrirModalVinculargrupo = () => setModalVincularGruposAberto(true);
    const zero = 0;
    const mensagemToast = useRef(null);

    if(mensagem === true) {
        mostrarMensagemSucesso(mensagemToast,'Midia cadastrada com sucesso!');
        setMensagem(false);
    }

    const visualizaMidia = rowData => (

        <i className="pi pi-eye"
            onClick={() => {
                abrirModalVisualizarMidia();
                setRowSelecionada(rowData);
            }} style={{ 'fontSize': '2em',
                color: '#03258C' }}></i>

    );

    const vincularGrupo = rowData => (

        <i className="pi pi pi-link"
            onClick={() => {
                abrirModalVinculargrupo();
                setRowSelecionada(rowData);
            }} style={{ 'fontSize': '2em',
                color: '#03258C' }}></i>

    );

    const bodyAcoes = rowData => (
        <div className="acoes" style={{ display: 'flex',
            gap: '8px',
            justifyItems: 'center',
            justifyContent: 'space-evenly',
            color: '#03258C'  }}>

            <i className="pi pi-trash"  onClick={() => {
                abrirModal();
                setRowSelecionada(rowData);
            }} style={{ 'fontSize': '2em' }}></i>
            <i className="pi pi-pencil"
                onClick={() => {
                    abrirModalEdicao();
                    setRowSelecionada(rowData);
                }} style={{ 'fontSize': '2em' }}></i>
        </div>
    );

    const header = <img src={FundoAmarelo} />;

    useEffect(() => {
        (async () => {
            try {
                const { data } = await MidiaService.buscarTodaMidias();
                const dataGrupo = await grupoTvService.getGrupo();

                setDadosGrupo(dataGrupo.data);
                setDadosParametros(data.reverse());
                setRecarregarDataTable(false);
            } catch {
                setRecarregarDataTable(false);
                throw new Error();
            }
        })();
    }, [recarregarDataTable]);

    return (
        <>
            <Growl ref={mensagemToast} />

            <Card className='tratar-scroll-card' header={header} title="Midias">
                <div className="p-grid p-fluid">
                    <div className="p-col size-spinner">
                        <Card style={{ fontSize: '11px' }}>
                            <Button
                                style={{ width: '95px' }}
                                label={'Cadastrar'}
                                onClick={setOpenModalCadastro.bind(this,true)}/>
                            <Dialog
                                header={'Uploand de imagens e videos'}
                                visible={openModalCadastro} onHide={setOpenModalCadastro}>
                                <CadastrarMidia
                                    setMensagem={setMensagem}
                                    dados={dados}

                                    setDados={setDados}
                                    rowSelecionada={rowSelecionada}
                                    setOpenModalCadastro={setOpenModalCadastro}
                                    setRecarregarDataTable={setRecarregarDataTable} />
                            </Dialog>
                        </Card>
                        <DataTable
                            paginator
                            responsive
                            rows={5}
                            style={{ textAlign: 'center',
                                overflow: 'hidden' }}
                            value={dadosParametros}
                            scrollable={false}
                            sortField="dataUpdated"
                            sortOrder={-1}
                            loading={recarregarDataTable}
                            loadingIcon="pi pi-spin pi-spinner"
                            emptyMessage="Sem midia cadastrada"
                        >
                            <Column
                                field="descricao"
                                header="Nome da midia"
                                style={{ width: '14rem',
                                    height: '4rem' }}
                                filter
                                filterPlaceholder="Filtrar por nome"
                            />

                            <Column
                                field="pathUrl"
                                header="Visualizar Midia"
                                body={visualizaMidia}
                                style={{
                                    overflow: 'hidden',
                                    width: '14rem',
                                    height: '4rem'
                                }}
                            />
                            <Column
                                field="Id_doc"
                                header="Vincular grupo"
                                body={vincularGrupo}
                                style={{
                                    overflow: 'hidden',
                                    width: '14rem',
                                    height: '4rem'
                                }}
                            />
                            <Column
                                header="Ações"
                                body={bodyAcoes}
                                style={{ width: '14rem',
                                    height: '4rem' }}
                            />
                        </DataTable>
                        <EditarMidia
                            mensagemToast={mensagemToast}
                            setDados={setDados}
                            rowSelecionada={rowSelecionada}
                            modalEdicaoAberto={modalEdicaoAberto}
                            setModalEdicaoAberto={setModalEdicaoAberto}
                            setRecarregarDataTable={setRecarregarDataTable}
                        />
                    </div>

                    <ExcluirRegistro
                        rowSelecionada={rowSelecionada}
                        modalAberto={modalAberto}
                        setModalAberto={setModalAberto}
                        setRecarregarDataTable={setRecarregarDataTable}
                    />

                    <VisualizarMidia
                        dadosGrupo={dadosGrupo}
                        rowSelecionada={rowSelecionada}
                        modalVincularTVAberto={modalVincularTVAberto}
                        setModalVincularTVAberto={setModalVisualizarMidiaAberto}
                        setRecarregarDataTable={setRecarregarDataTable}
                    />
                    <VincularGrupo
                        mensagemToast={mensagemToast}
                        dadosGrupo={dadosGrupo}
                        rowSelecionada={rowSelecionada}
                        modalVincularTVAberto={vincularGruposAberto}
                        setModalVincularTVAberto={setModalVincularGruposAberto}
                        setRecarregarDataTable={setRecarregarDataTable}
                    />
                </div>

            </Card>
        </>
    );
}
